// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils
import { sendAmplitudeEvent } from '../../../../../analytics/amplitudeService';

// Constants
import { EVENT_TYPE_NAMES } from '../../../../../../common/analytics/amplitudeEventTypesUtil';
import {
    BACKGROUND_COLOR_PREFIX,
    TEXT_COLOR_PREFIX,
} from '../../../../../components/editor/plugins/textColor/textColorConstants';

// Styles
import './TextColorButton.scss';

const TextColorButton = (props) => {
    const { currentStyle, preset, onTextColorClick } = props;

    const active = preset
        ? currentStyle.has(preset)
        : !currentStyle.some(
              (style) => style.startsWith(TEXT_COLOR_PREFIX) || style.startsWith(BACKGROUND_COLOR_PREFIX),
          );

    const onPointerDown = (event) => {
        // If we don't want to show the standard blue text selection style, then don't prevent default
        event.preventDefault();

        sendAmplitudeEvent({
            eventType: EVENT_TYPE_NAMES.TEXT_COLOR_TOGGLE,
            eventProperties: {
                color: preset,
            },
        });

        onTextColorClick(preset);
    };

    const presetClassname = preset ? preset.toLowerCase() : 'text-standard';

    return (
        <div className={classNames('TextColorButton', presetClassname, { active })} onPointerDown={onPointerDown}>
            A
        </div>
    );
};

TextColorButton.propTypes = {
    currentStyle: PropTypes.object,
    preset: PropTypes.string,
    className: PropTypes.string,
    onTextColorClick: PropTypes.func,
};

export default TextColorButton;
